import { IncomeWealthService } from './../../../income-wealth/service/income-wealth.service';
import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { DataList } from '../../model/data-list.model';
import { TrackTypes } from '../../../shared/service/journey/tracks/model/track-types';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { DomainOrigin } from '../../../shared/service/user-signup/model/domain-origin';
import { ProfessionService } from '../../../professional-data/service/profession.service';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
@Component({
  selector: 'app-client-data',
  templateUrl: './client-data.component.html',
  styleUrls: ['./client-data.component.scss']
})
export class ClientDataComponent extends DefaultPageComponent implements OnInit {

  public idComponentclientdata = 'clientData';
  title = 'Confira se os dados estão atualizados.';
  labelAria = '';
  buttonEnable = true;
  type = '';
  headerId = 'client-data';
  titleWebPage = 'Confira seus dados';
  titleProfile = 'Dados do contato';
  titlePersonal = 'Dados pessoais';
  titleMarital = 'Estado civil';
  titleAddress = 'Endereço';
  titleProfessional = 'Dados profissionais';
  titleIncome = 'Renda e patrimônio';
  itensProfile: DataList[] = [];
  itensPersonal: DataList[] = [];
  itensMarital: DataList[] = [];
  itensAddress: DataList[] = [];
  itensProfessional: DataList[] = [];
  itensIncome: DataList[] = [];
  editPersonal = '';
  editAddress = '';
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  dataUserOrigin;
  msgEditDisabledPersonal = '';
  msgEditDisabledAddress = '';

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    private titlePage: Title,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private professionService: ProfessionService,
    private incomeWealthService: IncomeWealthService,
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    const dataOriginTrack = this.journeyService.getCurrentTrack(this.headerId)?.parameters?.dataOrigin;

    this.dataUserOrigin = dataOriginTrack ? dataOriginTrack : this.dataUserOrigin;
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.loadData();
    this.verifyEdit();
    this.resetProfessionalPreviousData();
    this.resetDataIncomeWealthPrevious();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  isJourneyUpdate(journey: string) {
    return journey === TrackTypes.UPDATE_REGISTRATION ||
    journey === TrackTypes.UPDATE_PROFILE ||
    journey === TrackTypes.UPDATE_MARITAL ||
    journey === TrackTypes.UPDATE_ADDRESS ||
    journey === TrackTypes.UPDATE_PROFESSIONAL ||
    journey === TrackTypes.UPDATE_INCOME ||
    journey === TrackTypes.UPDATE_INCOME_CONTA_ION;
  }

  checkLoadDataNif(): boolean {
    return this.isJourneyUpdate(this.journeyService.journey) &&
    this.journeyService.registratioJourney?.data?.contaIon;
  }

  checkLoadDataNifOtherCountry(): boolean {
    return this.checkValueString(this.journeyService.registratioJourney?.data?.incomeEquity?.taxResidenceName) &&
    this.journeyService.registratioJourney?.data?.incomeEquity?.taxResidenceName.toUpperCase() !== 'BRASIL';
  }

  checkValueString(field: string, format?: boolean): string {
    if (field === undefined || field === null || field === '') {
      return format ? 'Não informado' : '';
    } else {
      return field;
    }
  }

  loadData() {
    this.itensProfile = [
      { field: 'Qual nome quer usar', description: this.journeyService.registratioJourney?.data?.profileData?.name },
      { field: 'E-mail', description: this.journeyService.registratioJourney?.data?.profileData?.email?.toLowerCase() },
      { field: 'Telefone', description: this.formartPhone(this.journeyService.registratioJourney?.data?.profileData?.phoneNumber)},
    ];
    this.itensPersonal = [
      { field: 'Nome Completo', description: this.journeyService.registratioJourney?.data?.personalData?.documentName },
      { field: 'Tipo de documento', description: this.journeyService.registratioJourney?.data?.personalData?.documentTypeName },
      { field: 'Número do documento', description: this.journeyService.registratioJourney?.data?.personalData?.documentNumber },
      { field: 'Orgão expedidor', description: this.journeyService.registratioJourney?.data?.personalData?.issuingAgencyName },
      { field: 'Estado', description: this.journeyService.registratioJourney?.data?.personalData?.expeditionState },
      { field: 'Data de nascimento', description: this.journeyService.registratioJourney?.data?.personalData?.dateOfBirth?.substr(0, 10).split('-').reverse().join('/') },
      { field: 'Nome da mãe', description: this.journeyService.registratioJourney?.data?.personalData?.motherName },
      { field: 'Nacionalidade', description: this.journeyService.registratioJourney?.data?.personalData?.nationalityName },
      { field: 'País de nascimento', description: this.journeyService.registratioJourney?.data?.personalData?.countryOfBirthName },
      { field: 'Estado de nascimento', description: this.journeyService.registratioJourney?.data?.personalData?.uFOfBirthName },
      { field: 'Cidade de nascimento', description: this.journeyService.registratioJourney?.data?.personalData?.cityOfBirthName },
      { field: 'Sexo atribuído no nascimento', description: this.journeyService.registratioJourney?.data?.personalData?.genderName },
    ];
    this.itensMarital = [
      { field: 'Estado civil', description: this.journeyService.registratioJourney?.data?.maritalStatus?.maritalStatusName },
      { field: 'Nome do cônjuge', description: this.journeyService.registratioJourney?.data?.maritalStatus?.spouseName },
      { field: 'CPF do cônjuge', description: this.journeyService.registratioJourney?.data?.maritalStatus?.spouseCpf
      ?.replace(/\D+/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})/, '$1-$2') },
    ];
    this.itensAddress = [
      {
        field: 'Endereço', description:
          `${this.checkValueString(this.journeyService.registratioJourney?.data?.address?.street) === ''
          ? '' : `${this.journeyService.registratioJourney?.data?.address?.street}, `}

          ${this.checkValueString(this.journeyService.registratioJourney?.data?.address?.number) === ''
          ? '' : `${this.journeyService.registratioJourney?.data?.address?.number}, `}

          ${this.checkValueString(this.journeyService.registratioJourney?.data?.address?.adjunct) === ''
          ? '' : `${this.journeyService.registratioJourney?.data?.address?.adjunct}, `}

          ${this.checkValueString(this.journeyService.registratioJourney?.data?.address?.district) === ''
          ? '' : `${this.journeyService.registratioJourney?.data?.address?.district}, `}

          ${this.checkValueString(this.journeyService.registratioJourney?.data?.address?.city) === ''
          ? '' : `${this.journeyService.registratioJourney?.data?.address?.city}-`}${this.checkValueString(this.journeyService.registratioJourney?.data?.address?.state)}`
      },
      { field: 'CEP', description: this.formartZipCode(this.journeyService.registratioJourney?.data?.address?.postalCode) }
    ];
    this.itensProfessional = [
      { field: 'Origem da ocupação', description: this.journeyService.registratioJourney?.data?.professionalData?.originIncomeName },
      { field: 'Profissão', description: this.journeyService.registratioJourney?.data?.professionalData?.professionName },
      { field: 'CNPJ da empresa', description: this.journeyService.registratioJourney?.data?.professionalData?.entityCnpj?.replace(/\D+/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") },
      { field: 'Nome da empresa', description: this.journeyService.registratioJourney?.data?.professionalData?.entityThatWorks },
    ];
    this.itensIncome = [
      { field: 'Renda mensal', description: this.currencyValue(this.journeyService.registratioJourney?.data?.incomeEquity?.income) },
      { field: 'Patrimônio financeiro total',
      description: this.currencyValue(this.journeyService.registratioJourney?.data?.incomeEquity?.patrimony) },
      (this.checkLoadDataNif()) ?
      { field: 'País de residência fiscal', description: this.checkValueString(this.journeyService.registratioJourney?.data?.incomeEquity?.taxResidenceName, true) } : {} as DataList,
      (this.checkLoadDataNif() && this.checkLoadDataNifOtherCountry()) ? 
      { field: 'Número de Identificação Fiscal (NIF)', description: this.checkValueString(this.journeyService.registratioJourney?.data?.incomeEquity?.nif, true) } : {} as DataList,
      (this.checkLoadDataNif() && this.checkLoadDataNifOtherCountry()) ? 
      { field: 'Data de início da residência fiscal', description: this.checkValueString(this.journeyService.registratioJourney?.data?.incomeEquity?.dateTaxResidency, true) } : {} as DataList
    ];
  }

  resetProfessionalPreviousData() {
    this.professionService.resetPreviousData();
  }

  resetDataIncomeWealthPrevious() {
    this.incomeWealthService.resetDataIncomeWealthPrevious();
  }

  currencyValue(value: string) {
    value = value?.replace('.', '').replace(',', '').replace(/\D/g, '');
    const options = { minimumFractionDigits: 2 };
    const result = new Intl.NumberFormat('pt-BR', options).format(
      parseFloat(value) / 100
    );

    return `R$ ${result}`;
  }

  formartPhone(value: string): string {
    const phone = value?.replace(/\D+/g, '')?.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

    if (value?.length === 11) {
      return phone?.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else {
      return phone?.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
  }

  formartZipCode(value: string): string {
    if (value?.length === 8) {
      return value?.replace(/^(\d{5})/, '$1-');
    } else {
      return value;
    }
  }

  verifyEdit() {
    if (this.isJourneyUpdate(this.journeyService.journey)) {
      this.editPersonal = undefined;
      this.editAddress = this.journeyService.registratioJourney?.data?.contaIon ? 'Editar' : undefined;
    } else {
      this.editPersonal = this.journeyService.registratioJourney?.data?.personalData?.firstEdit?.length > 0 ? 'Editar' : undefined;

      if (this.journeyService.registratioJourney?.data?.contaIon) {
        this.editAddress = 'Editar';
      } else {
        this.editAddress = this.journeyService.registratioJourney?.data?.address.firstEdit?.length > 0 ? 'Editar' : undefined;
      }
    }

    this.msgEditDisabledPersonal = this.journeyService.registratioJourney?.data?.contaIon
    ? 'Para alterar dados pessoais, entre em contato com a central de atendimento através do número 3003-9930 para capitais e regiões metropolitanas e 0800 720 9930 para demais regiões'
    : 'Atualize os dados pessoais pelo app do Itaú. No menu superior, acesse: Meu perfil > Minha conta > Meus dados cadastrais';

    this.msgEditDisabledAddress = this.journeyService.registratioJourney?.data?.contaIon
    || this.journeyService.registratioJourney?.data?.address?.firstEdit?.length > 0
    ? ''
    : 'Atualize o endereço pelo app do Itaú. No menu superior, acesse: Meu perfil > Minha conta > Meus dados cadastrais';
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.data;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathConfiraSeusDados,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  setTitle() {
    this.titlePage.setTitle(this.titleWebPage);
  }

  clickNext() {
    this.nextPage();
  }

  analyticsEventClique(label: string) {
    const it_eventcategory = 'Clique';
    const it_complementary = { 
              it_eventaction: this.analyticsPage.action,
              it_eventlabel: label,
              it_pagename: this.analyticsPage.data
            };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }

  editField(event: any) {
    if (this.isJourneyUpdate(this.journeyService.journey)) {
      this.editRegistration(event, 'update');
    } else {
      this.editRegistration(event, 'basic');
    }
  }

  editRegistration(event: any, type: string) {
    if(this.dataUserOrigin === DomainOrigin.UpdateRegistration) {
      switch (event) {
        case this.titleProfile:
          this.analyticsEventClique(`${this.analyticsPage.check}DadosContato`);
          this.router.navigateForward(['profile', 'name'], { queryParams: { journey: `${type}-profile` } });
          break;
        case this.titlePersonal:
          this.analyticsEventClique(`${this.analyticsPage.check}DadosPessoais`);
          this.router.navigateForward(['personal-data', 'document-type'], { queryParams: { journey: `${type}-personal` } });
          break;
        case this.titleMarital:
          this.analyticsEventClique(`${this.analyticsPage.check}EstadoCivil`);
          this.router.navigateForward(['marital-status', 'marital-status'], { queryParams: { journey: `${type}-marital` } });
          break;
        case this.titleAddress:
          this.analyticsEventClique(`${this.analyticsPage.check}Endereco`);
          this.router.navigateForward(['address', 'cep'], { queryParams: { journey: `${type}-address` } });
          break;
        case this.titleProfessional:
          this.analyticsEventClique(`${this.analyticsPage.check}DadosProfissionais`);
          this.router.navigateForward(['professional-data', 'origin-income'], { queryParams: { journey: `${type}-professional` } });
          break;
        case this.titleIncome:
          this.analyticsEventClique(`${this.analyticsPage.check}RendaPatrimonio`);
          this.setRouterUpdateIncome(type);
          break;
        default:
          break;
      }
    } else {
      switch (event) {
        case this.titleProfile:
          this.analyticsEventClique(`${this.analyticsPage.check}DadosContato`);
          this.router.navigateForward(['profile', 'name'], { queryParams: { journey: `${type}-profile-v2` } });
          break;
        case this.titlePersonal:
          this.analyticsEventClique(`${this.analyticsPage.check}DadosPessoais`);
          this.router.navigateForward(['personal-data', 'document-type'], { queryParams: { journey: `${type}-personal-v2` } });
          break;
        case this.titleMarital:
          this.analyticsEventClique(`${this.analyticsPage.check}EstadoCivil`);
          this.router.navigateForward(['marital-status', 'marital-status'], { queryParams: { journey: `${type}-marital-v2` } });
          break;
        case this.titleAddress:
          this.analyticsEventClique(`${this.analyticsPage.check}Endereco`);
          this.router.navigateForward(['address', 'cep'], { queryParams: { journey: `${type}-address-v2` } });
          break;
        case this.titleProfessional:
          this.analyticsEventClique(`${this.analyticsPage.check}DadosProfissionais`);
          this.router.navigateForward(['professional-data', 'origin-income'], { queryParams: { journey: `${type}-professional-v2` } });
          break;
        case this.titleIncome:
          this.analyticsEventClique(`${this.analyticsPage.check}RendaPatrimonio`);
          this.router.navigateForward(['income', 'income-wealthincome'], { queryParams: { journey: `${type}-income-v2` } });
          break;
        default:
          break;
      }
    }
  }

  backPage() {
    this.analyticsEventClique(this.analyticsPage.back);

    if (this.isJourneyUpdate(this.journeyService.journey)) {
      this.backJourney();
    } else {
      this.router.navigateForward(['overview-status', 'overview-user']);
    }
  }

  setRouterUpdateIncome(type: string) {
    if (this.journeyService.registratioJourney?.data?.contaIon === true) {
        return this.router.navigateForward(['income', 'income-wealthincome'], { queryParams: { journey: `${type}-income-conta-ion` } });
    } else {
      return this.router.navigateForward(['income', 'income-wealthincome'], { queryParams: { journey: `${type}-income` } });
    }
  }
}
